import script from "./ReferencesSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferencesSlide.vue?vue&type=script&setup=true&lang=js"

import "./ReferencesSlide.vue?vue&type=style&index=0&id=68bc5c16&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68bc5c16"]])

export default __exports__